define(["require", "exports", "knockout", "../utils/dateUtils"], function (require, exports, ko, dateUtils) {
    "use strict";
    var IpAddressModel = /** @class */ (function () {
        function IpAddressModel(data) {
            this.Id = ko.observable(0);
            this.GroupName = ko.observable("AllowIP");
            this.IpAddress = ko.observable();
            this.Comment = ko.observable();
            this.CustomerId = ko.observable();
            this.CustomerName = ko.observable();
            this.CustomerNote = ko.observable();
            this.NotifyExpiration = ko.observable();
            this.StartOn = ko.observable(dateUtils.today());
            this.EndOn = ko.observable(dateUtils.addDays(dateUtils.today(), 90));
            this.Recipients = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, IpAddressModel.Mapping, self);
            }
        }
        IpAddressModel.prototype.newItem = function () {
            var self = this;
            if (self) {
                self.Recipients.push("");
            }
        };
        IpAddressModel.prototype.removeItem = function (self, item) {
            console.log(self, item);
            if (self && self.Recipients && self.Recipients().length) {
                self.Recipients.remove(item);
            }
        };
        IpAddressModel.prototype.onChange = function (self, val, e) {
            console.log(self, val, e);
            if (e) {
                var el = e.srcElement;
                var index = parseInt(el.getAttribute('data-index'));
                self.Recipients()[index] = el.value;
            }
        };
        IpAddressModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new IpAddressModel(options.data);
            },
            StartOn: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            },
            EndOn: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return IpAddressModel;
    }());
    return IpAddressModel;
});
//# sourceMappingURL=IpAddressModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/IpAddressModel.js
// module id = 205
// module chunks = 2